var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17669 17.2062C6.63287 17.5979 7.36835 17.5979 7.82454 17.2062L15.5611 10.5635C15.9241 10.2518 15.9241 9.7482 15.5611 9.43645L7.82454 2.79377C7.36835 2.40208 6.63287 2.40208 6.17669 2.79377C5.7205 3.18545 5.7205 3.81695 6.17669 4.20863L12.917 10.004L6.16738 15.7994C5.7205 16.1831 5.7205 16.8225 6.17669 17.2062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.e051eb71.svg";
export { ForwardRef as ReactComponent };